import { FC, useRef } from "react"
import { useAtomValue, useSetAtom } from "jotai"
import { useTar } from "@/modules/i18n"
import { WysiwygEditor } from "@/components/WysiwygEditor"
import { workspaceChartsAtom, workspaceSolutionHandlersAtom } from "@/store/workspaceAtoms"
import { currentSolutionAtom } from "@/store/saveWorkAtoms"

export const SolutionTab: FC = () => {
    const { t } = useTar()
    const solution = useAtomValue(currentSolutionAtom)
    const setCurrentSolution = useSetAtom(currentSolutionAtom)
    const charts = useAtomValue(workspaceChartsAtom)
    const handlers = useAtomValue(workspaceSolutionHandlersAtom)
    const solutionRef = useRef(solution)
    solutionRef.current = solution

    if (!handlers || !charts) {
        return null
    }

    return (
        <div className="h-full min-h-full flex flex-col overflow-hidden">
            <WysiwygEditor
                content={solution}
                contentGetter={() => solutionRef.current}
                onChange={(newSolution) => {
                    setCurrentSolution(newSolution)
                    handlers.handleSolutionChange(newSolution)
                }}
                acceptSolutionInsert
                handleChartAdded={handlers.handleChartAdded}
                handleChartRemoved={handlers.handleChartRemoved}
                startingCharts={charts}
                placeholder={t('common.solveHere')}
                className="flex-1 min-h-0 p-0"
            />
        </div>
    )
}
